import React from "react";
import { Link } from "react-router-dom";
import { Home, Search, MessageCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function NotFound() {
  // Track 404s in GA4 (best-effort, optional)
  React.useEffect(() => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "page_not_found", {
        page_path: window.location.pathname,
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-blue-50/40 flex items-center justify-center px-4 py-10">
      <div className="max-w-xl w-full text-center" data-testid="not-found-root">
        <img
          src="/icons/nav-brain.png"
          alt="NeuroOpinion India"
          className="w-24 h-24 mx-auto opacity-90"
          width={96}
          height={96}
        />
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-blue-700 mt-6">
          Error · 404
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900 mt-3 tracking-tight">
          Page not found
        </h1>
        <p className="text-base text-slate-600 mt-3 leading-relaxed max-w-md mx-auto">
          The link you followed may be broken or the page may have moved.
          But your brain health questions still have answers — let&apos;s get
          you somewhere useful.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch justify-center gap-3 max-w-md mx-auto">
          <Link to="/" className="flex-1">
            <Button className="w-full h-11 bg-blue-700 hover:bg-blue-800" data-testid="not-found-home-btn">
              <Home className="w-4 h-4 mr-2"/> Back to home
            </Button>
          </Link>
          <Link to="/conditions" className="flex-1">
            <Button variant="outline" className="w-full h-11 border-slate-300" data-testid="not-found-conditions-btn">
              <Search className="w-4 h-4 mr-2"/> Browse conditions
            </Button>
          </Link>
        </div>

        <a
          href="https://wa.me/918317674160"
          className="inline-flex items-center gap-1.5 mt-6 text-sm text-emerald-700 hover:text-emerald-800 font-semibold"
          data-testid="not-found-whatsapp"
        >
          <MessageCircle className="w-4 h-4"/> WhatsApp our care team
        </a>

        <div className="mt-12 text-[11px] text-slate-400 tracking-wide">
          <Link to="/" className="hover:text-slate-700 inline-flex items-center gap-1">
            <ArrowLeft className="w-3 h-3"/> neuroopinion.in
          </Link>
        </div>
      </div>
    </div>
  );
}
